import axios from 'axios';

class MobileMenu {
  constructor() {

    this.current_tier = 0;
    this.chain = [];
  
    this.pane = jQuery('aside.sidenav-menu .mobile-main-menu-pane');
    this.pane_content = jQuery('aside.sidenav-menu .mobile-main-menu-pane .menu-content');
    this.pane_title = jQuery('aside.sidenav-menu .mobile-main-menu-pane .menu-title');
    this.pane_tier_title = jQuery('aside.sidenav-menu .mobile-main-menu-pane .menu-tier-title');

    this.expandList = [
      {
        $: '.mobile-main-menu-pane .menu-item-type-buywine-countries.menu-slug-other-countries > a',
        endpoint: '/menu/buy-wine/countries',
      },
      {
        $: '.mobile-main-menu-pane .menu-item-type-buywine-finewineregions.menu-slug-other-regions > a',
        endpoint: '/menu/buy-wine/regions',
      },
      {
        $: '.mobile-main-menu-pane .menu-item-type-broking-countries.menu-slug-other-countries > a',
        endpoint: '/menu/broking/countries',
      },
      {
        $: '.mobile-main-menu-pane .menu-item-type-broking-finewineregions.menu-slug-other-regions > a',
        endpoint: '/menu/broking/regions',
      },
      {
        $: '.mobile-main-menu-pane .menu-item-type-broking-classification.menu-slug-other-classifications > a',
        endpoint: '/menu/broking/classifications',
      },
      {
        $: '.mobile-main-menu-pane .menu-item-type-spirits-type.menu-slug-other-types > a',
        endpoint: '/menu/spirits/types',
      },
      {
        $: '.mobile-main-menu-pane .menu-item-type-spirits-style.menu-slug-other-styles > a',
        endpoint: '/menu/spirits/styles',
      },
      {
        $: '.mobile-main-menu-pane .menu-item-type-spirits-regions.menu-slug-other-regions > a',
        endpoint: '/menu/spirits/regions',
      },
    ];
  }

  createTermListElement($parent) {
    var $termlist = jQuery('<ul class="mobile-termlist loading"></ul>');

    $parent.parent('li.menu-item').append($termlist);

    return $termlist;
  }

  setSidebarMenu(el, tier = 0) {
    var self = this;

    function handleSidebarSubMenuClick(e) {
      if (
        jQuery(this)
          .parent('.menu-item')
          .children('.sub-menu').length > 0
      ) {
        e.preventDefault();
        self.current_tier++;
        self.chain.push(jQuery(this).parent('.menu-item'));
        self.setSidebarMenu(
          jQuery(this).parent('.menu-item'),
          self.current_tier
        );
      }
      return;
    }

    if (el.children('.sub-menu').length === 0) {
      this.pane.addClass('transparent');
      this.pane_title.html('');
      this.pane_content.html('');
      jQuery('.mobile-main-menu-pane').on('click', function() {
        window.closeSidebarMenu();
      });
    } else {
      this.pane.removeClass('transparent');
      if (tier === 0) {
        this.pane_title.html(
          el
            .children('a')
            .first()
            .text()
        );
        this.pane_title.removeClass('back-tier');
        this.pane_title.off('click');
        this.pane_tier_title.html('');
      } else {
        this.pane_title.addClass('back-tier');
        this.pane_title.off('click');
        this.pane_tier_title.html('<a>'+
          this.chain[this.current_tier]
            .children('a')
            .first()
            .text()+'</a>'
        );
        this.pane_tier_title.children('a').first().attr('href',
          this.chain[this.current_tier]
            .children('a')
            .first()
            .attr('href')
        );

        this.pane_title.on('click', function() {
          self.current_tier--;
          self.setSidebarMenu(self.chain[self.current_tier], self.current_tier, el);
          self.chain.pop();
        });
      }
      this.pane_content.html(
        el
          .children('.sub-menu')
          .first()
          .get(0).outerHTML
      );
      jQuery('.mobile-main-menu-pane').off('click');

      this.pane.find('.menu-content > ul.sub-menu > .menu-item').each(function() {
        jQuery('> a', this).off('click');
        jQuery('> a', this).on('click', handleSidebarSubMenuClick);
      });
    }

    this.registerPaneEventHandlers();
    
  }

  registerPaneEventHandlers() {
    var self = this;

    for (var i in this.expandList) {

        jQuery(this.expandList[i].$).data('endpoint', this.expandList[i].endpoint);
        jQuery(this.expandList[i].$).parent('.menu-item').addClass('menu-has-termlist');
        jQuery(this.expandList[i].$).on('click', function(e) {

          e.preventDefault();
       
          var $this = $(this);

          var $termlist = $this.parent('.menu-item').children('.mobile-termlist');

          if($this.parent('.menu-item').hasClass('in')) {
            $this.parent('.menu-item').removeClass('in');
            $termlist.remove();
            return;
          } else {
            $this.parent('.menu-item').addClass('in');
            $termlist = self.createTermListElement($this);
            window.scrollBy(0, 120);
          }
  
          axios({
            method: 'get',
            url: window._D.jsonUrl + $this.data('endpoint'),
          }).then(response => {
            if (response.status === 200) {
              
                for(var i in response.data) {
                    $termlist.append('<li class="menu-item"><a href="' + response.data[i].url + '">' + response.data[i].text + '</a></li>');
                }

                $termlist.removeClass('loading');
            
            } else {
              $termlist.removeClass('loading');
              throw new Error('E_MENUFAIL', 'Failed to get full menu');
            }
          });
        });
      }
  }

  formatDOM() {
    var self = this;

    jQuery(
      '.mobile-main-menu > ul > .current-menu-item, .mobile-main-menu > ul > .current-menu-parent'
    ).each(function() {
      jQuery(this).addClass('selected');
      self.setSidebarMenu(jQuery(this));
      self.chain = [jQuery(this)];
    });

    jQuery('.mobile-main-menu > ul > li > a').each(function() {
      jQuery(this).on('click', function(e) {
        self.current_tier = 0;
        self.chain = [jQuery(this).parent('li')];

        if (
          jQuery(this)
            .parent('li')
            .children('.sub-menu').length > 0
        ) {
          e.preventDefault();
          jQuery('.mobile-main-menu > ul > li.selected').removeClass(
            'selected'
          );
          jQuery(this)
            .parent('li')
            .addClass('selected');
          self.setSidebarMenu(jQuery(this).parent('li'));
        }
      });
    });

    jQuery('.mobile-main-menu .menu-item').each(function() {
      if (jQuery(this).find('> .sub-menu').length > 0) {
        jQuery(this).addClass('menu-has-children');
      }
    });
  }

  init() {
    this.formatDOM();
    this.registerPaneEventHandlers();

    jQuery('.mobile-main-menu .menu-slug-buy-wine a').click();
  }
}

var menu = new MobileMenu();

export default menu;



// WEBPACK FOOTER //
// ./scripts/modules/mobile-menu.js